import {
	del,
	get,
	post,
	put,
	toExcel,
	upload
} from './axios'
export const server = {
	exam(paramObj) { //测试
		return post('/backend/feedback/update', paramObj);
	},
	login(paramObj) { //登录
		return post('/backend/manageuser/dologin', paramObj);
	},
	logOut(){
	return get('/backend/manageuser/del/logOut')
	},
	homeDate(paramObj) { //统页面
		return post('/backend/miningPool/find/poolById', paramObj);
	},
	getUserInfo() { //获取登录用户信息
		return get('/backend/manageuser/get/user');
	},
	uploadFile(data, type) { //图片上传
		return upload('?type=' + type, data);
	},
	findByManageUserIdManageFunction() { //菜单
		return get('/backend/function/findByManageUserIdManageFunction');
	},
	queryManageRoleWhere(paramObj) { //角色列表查询
		return post('/backend/role/queryManageRoleWhere', paramObj);
	},
	findManageFunction() { //角色权限列表查询
		return get('/backend/function/findManageFunction');
	},
	insertRoleFunction(paramObj) { //添加角色权限
		return post('/backend/roleFunction/insertRoleFunction', paramObj);
	},
	findById() { //查询当前用户id
		return get('/backend/manageuser/findById');
	},
	queryManageUserWhere(paramObj) { //查询用户管理列表
		return post('/backend/manageuser/queryManageUserWhere', paramObj);
	},
	insertUserRole(paramObj) { //添加：查询用户管理列表(管理员。超级管理员，普通用户)
		return post('/backend/userRole/insertUserRole', paramObj);
	},
	//添加角色
	insertRole(paramObj) {
		return post('/backend/role/insertRole', paramObj)
	},
	//根据id查询角色
	findRoleById(id) {
		return get('/backend/role/findById/' + id);
	},
	
	//编辑角色
	editRole(paramObj) {
		return put('/backend/role/updateRole', paramObj)
	},
	//删除角色
	deleteRole(id) {
		return del('/backend/role/delRole/' + id)
	},
	//根据角色ID查询该用户所拥有的菜单权限
	findMenusById(id) {
		return get('/backend/function/findFunctionByRoleId/' + id);
	},
	//添加用户
	insertSysUser(paramObj) {
		return post('/backend/manageuser/register', paramObj)
	},
	//根据用户ID查询该用户所拥有的菜单权限
	findSysUserById(id) {
		return get('/backend/manageuser/findById?userId=' + id);
	},
	//充值系统用户密码
	editSysUserPassword(paramObj) {
		return put('/backend/manageuser/updateManageUser', paramObj)
	},
	deactivateSysUser(id) { //停用启用系统用户
		return get('/backend/manageuser/status/' + id)
	},
	//编辑系统用户
	editSysUser(paramObj) {
		return post('/backend/manageuser/edit', paramObj)
	},
	//删除系统用户
	deleteSysUser(id) {
		return del('/backend/manageuser/deleteManageUser/' + id)
	},
	//根据用户ID查询该用户所拥有的角色权限
	findRoleByUserId(id) {
		return get('/backend/role/findByManageUserId/' + id);
	},
	//根据用户ID查询该用户所拥有的仓库权限
	findWarehouseByUserId(id) {
		return get('/backend/wmsWarehouseManager/get/' + id);
	},
	// 用户ID添加仓库权限
	insertWarehouseFunction(paramObj) {
		return post('/backend/wmsWarehouseManager/add', paramObj);
	},

	//多条件查询菜单列表（父级包子级）
	getMenusList() {
		return get('/backend/function/findManageFunction')
	},
	//查询所有菜单列表
	getAllMenus(paramObj) {
		return post('/backend/function/findManageFunctionWhere', paramObj)
	},
	//添加菜单
	insertMenus(paramObj) {
		return post('/backend/function/insertFunction', paramObj)
	},
	//根据用户ID查询菜单
	findMenueByUserId(id) {
		return get('/backend/function/findById/' + id);
	},
	//编辑菜单
	editMenus(paramObj) {
		return put('/backend/function/updateFunction', paramObj)
	},
	//删除菜单
	deleteMenus(id) {
		return del('/backend/function/delFunction/' + id)
	},
	//查询所有参数设置列表
	getAllSysSetting(paramObj) {
		return post('/api/sysSetting/findByWhere', paramObj)
	},
	//根据id查询参数设置信息
	getSysSettingInfoById(paramObj) {
		return get('/api/sysSetting/findById/' + paramObj)
	},
	//根据id查询参数设置信息
	editSysSettingInfoById(paramObj) {
		return post('/api/sysSetting/upSysSetting', paramObj)
	},
	//多条件查询会员列表
	getUserList(paramObj) {
		return post('/backend/user/seluser', paramObj)
	},

	// //禁用用户
	disableUserInfo(paramObj) {
		return post('/backend/user/disable', paramObj)
	},
	// //获取用户资产
	getUserProperty(paramObj) {
		return post('/backend/property/get/userinfos', paramObj)
	},

	// //资产列表
	getIntegralList(paramObj) {
		return post('/api/integral/get/list', paramObj)
	},
	// // 管理用户重置密码
	sysResetPass(paramObj) {
		return put('/backend/manageuser/updatePassword', paramObj)
	},
	// // 管理用户支付密码
	retrievePassword(paramObj) {
		return post('/backend/manageuser/retrieveuserWalletPassword', paramObj)
	},
	findManageUserById(paramObj) {
		return post('/backend/manageuser/findManageUserById/'+paramObj)
	},
	upgoodsstock(paramObj,pas) {
		return get('/backend/storeGoods/edit/ModifyInventory/'+paramObj+'/'+pas)
	},
	
	// //根据id查询用户信息
	getUserInfoById(paramObj) {
		return get('/backend/user/get/Eduser', paramObj)
	},
	// //编辑用户信息
	editUserInfoById(paramObj) {
		return post('/backend/user/edit/editUser', paramObj)
	},
	// 会员重置密码
	resetPass(paramObj) {
		return post('/backend/user/edit/editUser', paramObj)
	},
	deltGoodsClass(paramObj) {
		return post('/backend/goodsClass/find/deleteGoodsClass', paramObj)
	},
	// 拨币
	getIntegralAppropriation(paramObj) {
		return post('/backend/user/appropriation', paramObj)
	},
	//用户邀请下级显示
	showInvite(paramObj) {
		return post('/backend/user/invite', paramObj);
	},
	//设置区域代理
	editSetLevel(paramObj) {
		return post('/backend/user/add/setUpProxy', paramObj);
	},
	//多条件查询账单记录列表
	getUserPoolList(paramObj) {
		return post('/backend/userPool/find/findWhere', paramObj)
	},
	//多条件查询账单记录列表
	getUserRecordList(paramObj) {
		return post('/backend/tradingRecord/findByWhere', paramObj)
	},
	// 多条件查询账单记录列表统计值
	getUserRecordListSum(paramObj) {
		return post('/backend/tradingRecord/recordSum', paramObj)
	},

	// 首领业绩报表查询
	findLeaderPerformanceList(paramObj) {
		return post('/backend/equipMemberContribution/find/findLeaderPerformanceList', paramObj)
	},

	// 月商城业绩报表查询
	getShopMemberContributionList(paramObj) {
		return post('/backend/shopMemberContribution/find/getShopMemberContributionList', paramObj)
	},

	// 月商城业绩排行报表查询
	findShopMemberContributionList(paramObj) {
		return post('/backend/shopMemberContribution/find/findShopMemberContributionList', paramObj)
	},

	//多条件查询账单类型列表
	getRecordTypeList(paramObj) {
		return post('/backend/tradingRecordType/findByWhere', paramObj)
	},

	//多条件查询资产记录列表
	getUserPropertyList(paramObj) {
		return post('/backend/property/get/userinfos', paramObj)
	},
	//统计多条件查询资产记录列表
	getStatisticsUserPropertyList(paramObj) {
		return post('/backend/property/list/sum', paramObj)
	},

	//查询提现申请列表
	findByIntegralWithdrawalList(paramObj) {
		return post('/backend/integralWithdrawal/find/findByIntegralWithdrawalList', paramObj)
	},
	//根据id查询提现申请信息
	findBuyIntegralWithdrawalId(paramObj) {
		return get('/backend/integralWithdrawal/find/findBuyIntegralWithdrawalId/' + paramObj)
	},
	//打款中
	playGame(paramObj) {
		return get('/backend/integralWithdrawal/edit/playGame/' + paramObj)
	},
	//已打款
	haveMoney(paramObj) {
		return post('/backend/integralWithdrawal/edit/haveMoney', paramObj)
	},
	//提现申请 驳 回
	integralWithdrawalReject(paramObj) {
		return post('/backend/integralWithdrawal/edit/reject', paramObj)
	},
	//统计多条件查询充值提币总值
	getStatisticsUserIntegralLogList(paramObj) {
		return post('/backend/integralWithdrawal/find/WithdrawDepositRecord/sum', paramObj)
	},

	//根据ID查询提币记录
	findLogById(id) {
		return get('/backend/block/log/' + id);
	},
	//提币审核通过
	getWithdrawCoin(paramObj) {
		return post('/backend/block/withdrawCoin', paramObj)
	},

	//提币审核通过
	affirm(id) {
		return get('/backend/block/affirm/' + id)
	},
	//矿主业绩统计
	getUserLevel(paramObj) {
		return post('/api/user/find/team/equip', paramObj)
	},

	// 公告列表
	getNotifyList(paramObj) {
		return post('/backend/notify/selnotify', paramObj)
	},
	// id查询公告列表
	getNotifyById(paramObj) {
		return get('/backend/notify/selobjnotify?id=' + paramObj)
	},
	// id编辑公告列表
	editNotify(paramObj) {
		return post('/backend/notify/update', paramObj)
	},
	// id添加公告列表
	addNotify(paramObj) {
		return post('/backend/notify/addto', paramObj)
	},
	// id删除公告列表
	delNotify(paramObj) {
		return get('/backend/notify/del?id=' + paramObj)
	},
	// 分页查询消息分类列表
	selMessageType(paramObj) {
		return post('/backend/messagetype/selmessagetypepage', paramObj)
	},
	// 添加消息
	addMessage(paramObj) {
		return post('/backend/message/addto', paramObj)
	},
	// 修改消息
	upMessage(paramObj) {
		return post('/backend/message/update', paramObj)
	},
	// 查询消息信息（分页）
	selMessageList(paramObj) {
		return post('/backend/message/selmessage', paramObj)
	},
	// 查询消息信息对象
	queryMessage(paramObj) {
		return post('/backend/message/selobjmessage', paramObj)
	},
	// 根据id删除消息信息
	delMessage(paramObj) {
		return post('/backend/message/del?id=' + paramObj)
	},
	// 查询阅读记录
	queryMessageUserRead(paramObj) {
		return post('/backend/messageUserRead/readingRecord', paramObj)
	},

	// 添加消息分类
	addMessageType(paramObj) {
		return post('/backend/messageType/add/addMessageType', paramObj)
	},
	// 修改消息分类
	upMessageType(paramObj) {
		return post('/backend/messageType/edit/updateiMessageType', paramObj)
	},
	// 删除消息分类
	delMessageType(paramObj) {
		return post('/backend/messageType/del/upiIsDelete/' + paramObj)
	},
	// 分页查询消息分类列表
	selMessageType(paramObj) {
		return post('/backend/messageType/find/findByWhere', paramObj)
	},
	// 添加消息
	addMessage(paramObj) {
		return post('/backend/message/add/addMessage', paramObj)
	},
	// 修改消息
	upMessage(paramObj) {
		return post('/backend/message/edit/updateiMessage', paramObj)
	},
	// 查询消息信息（分页）
	selMessageList(paramObj) {
		return post('/backend/message/find/findByWhere', paramObj)
	},
	// 根据id查询消息信息对象
	queryMessageById(paramObj) {
		return get('/backend/message/find/findById/' + paramObj)
	},
	// 根据id删除消息信息
	delMessage(paramObj) {
		return get('/backend/message/del/upiIsDelete/' + paramObj)
	},
	// 查询阅读记录
	queryMessageUserRead(paramObj) {
		return post('/backend/messageUserRead/find/findByWhere', paramObj)
	},


	//添加反馈类型
	addFeedbackType(paramObj) {
		return post('/backend/feedbackType/add/addFeedbackType', paramObj)
	},
	//根据id查询反馈类型
	findByIdFeedbackType(paramObj) {
		return get('/backend/feedbackType/find/findById/' + paramObj)
	},
	//修改反馈类型
	updateFeedbackType(paramObj) {
		return post('/backend/feedbackType/edit/updateFeedbackType', paramObj)
	},
	//根据id删除或取消删除
	upIsDeleteFeedbackType(paramObj) {
		return get('/backend/feedbackType/del/upIsDelete/' + paramObj)
	},
	//根据id启用或禁用
	upIsEnableFeedbackType(paramObj) {
		return get('/backend/feedbackType/edit/upIsEnable/' + paramObj)
	},
	//条件查询反馈类型
	findByWhereFeedbackType(paramObj) {
		return post('/backend/feedbackType/find/findByWhere', paramObj)
	},
	//查询反馈节点
	findByWhereFeedbackNode(paramObj) {
		return post('/backend/feedback/find/queryFeedbackNode', paramObj)
	},
	//回复
	addFeedbackNode(paramObj) {
		return post('/backend/feedback/add/addFeedback', paramObj)
	},
	//条件查询
	findByWhereFeedback(paramObj) {
		return post('/backend/feedback/find/findByWhere', paramObj)
	},
	//反馈节点状态修改
	upStatusFeedbackNode(paramObj) {
		return get('/backend/feedback/edit/upStatus', paramObj)
	},


	// 资产列表
	getIntegralInfoById(paramObj) {
		return get('/backend/integral/info/' + paramObj)
	},
	// 编辑资产列表
	editIntegralInfoById(paramObj) {
		return put('/backend/integral/edit/integral', paramObj)
	},
	//闪兑资产列表
	getExchangeList(paramObj) {
		return post('/backend/flashExchangeIntegral/find/flashExchangeCoin', paramObj)
	},
	//添加闪兑资产列表
	addExchangeInfo(paramObj) {
		return post('/backend/flashExchangeIntegral/add/flashExchangeCoin', paramObj)
	},
	//编辑闪兑资产列表
	editExchangeInfo(paramObj) {
		return post('/backend/flashExchangeIntegral/edit/flashExchangeCoin', paramObj)
	},
	//删除闪兑资产列表
	delExchangeInfo(paramObj) {
		return get('/backend/flashExchangeIntegral/del/flashExchangeCoin/' + paramObj)
	},
	//闪兑资产列表
	getExchangeRecordList(paramObj) {
		return post('/backend/flashExchange/find/flashExchange/record', paramObj)
	},


	//查询商品列表
	getStoreGoodsList(paramObj) {
		return post('/backend/storeGoods/find/findByWhere', paramObj)
	},

	//商品审核
	storeGoodsReview(paramObj) {
		return post('/backend/storeGoods/edit/storeGoodsReview', paramObj)
	},
	//商品上下架
	storeGoodsHitTheShelfOrSoldOut(paramObj) {
		return get('/backend/storeGoods/edit/hitTheShelfOrSoldOut/' + paramObj)
	},
	//商品删除
	delStoreGoods(paramObj) {
		return get('/backend/storeGoods/del/delStoreGoods/' + paramObj)
	},
	//根据id查询商品
	storeGoodsFindById(paramObj) {
		return get('/backend/storeGoods/find/findById/' + paramObj)
	},
	//添加商品
	addStoreGoods(paramObj) {
		return post('/backend/storeGoods/add/addStoreGoods', paramObj)
	},
	//添加编辑商品
	editStoreGoods(paramObj) {
		return post('/backend/storeGoods/edit/editStoreGoods', paramObj)
	},

	//编辑商户
	updateStore(paramObj) {
		return post('/backend/store/edit/updateOthersStore', paramObj)
	},
	//编辑其他商家得
	updateStores(paramObj) {
		return post('/backend/store/edit/updateStore', paramObj)
	},
		//删除商户
	delStore(paramObj) {
		return get('/backend/store/del/delStore/'+paramObj)
	},
	 
	//根据商品分类id查询商品分类信息
	findByGoodsClassId(paramObj) {
		return get('/backend/goodsClass/find/findByGoodsClassId/' + paramObj)
	},
	//联系人查询
	findStoreLinksByStoreId(paramObj) {
		return get('/backend/storeLinks/find/findStoreLinks/'+ paramObj)
	},
	//联系人新增
	addStoreLinks(paramObj) {
		return post('/backend/storeLinks/add/addStoreLinks', paramObj)
	},
	//联系人编辑
	editStoreLinks(paramObj) {
		return post('/backend/storeLinks/edit/editStoreLinks', paramObj)
	},
	findStoreLinksById(paramObj) {
		return get('/backend/storeLinks/find/findStoreLinksById/'+ paramObj)
	},
	
	//联系人删除
	delStoreLinks(paramObj) {
		return get('/backend/storeLinks/del/delStoreLinks/'+ paramObj)
	},
	
	//添加修改社区分类信息
	addStoreClass(paramObj) {
		return post('/backend/storeClass/store/addStoreClass', paramObj)
	},
	//删除社区分类信息
	delStoreClass(paramObj) {
		return get('/backend/storeClass/store/delStoreClass/' + paramObj)
	},
	//根据分类等级查询分类列表
	findByGoodsClassLevel(paramObj) {
		return post('/backend/goodsClass/find/findByGoodsClassLevel', paramObj)
	},
	//根据pid查询商品分类
	goodsClassfindByPid(paramObj) {
		return post('/backend/goodsClass/find/findByPid', paramObj)
	},
	//商品分类1,2,3级 一起查询
	findGoodsClassInfo(paramObj) {
		return post('/backend/goodsClass/find/findGoodsClassInfo', paramObj)
	},
	//社区分类一起查询
	findStoreClass(paramObj) {
		return post('/backend/storeClass/findStoreClass', paramObj)
	},
	//社区商品分类一起查询
	findGoodsClassInfoOffline(paramObj) {
		return post('/backend/ssGoodsClass/findTSsGoodsClass', paramObj)
	},
	//添加商品分类
	addGoodsClass(paramObj) {
		return post('/backend/goodsClass/add/addGoodsClass', paramObj)
	},
	//查询店铺列表
	getStoreList(paramObj) {
		return post('/backend/store/find/findBywhere', paramObj)
	},
	getStoreId(paramObj) {
		return get('/backend/store/find/storeById/' + paramObj)
	},
	//根据商品分类id查询商品分类信息
	findByGoodsClassId(paramObj) {
		return get('/backend/goodsClass/find/findByGoodsClassId/' + paramObj)
	},
	//根据分类等级查询分类列表
	findByGoodsClassLevel(paramObj) {
		return post('/backend/goodsClass/find/findByGoodsClassLevel', paramObj)
	},
	//商品分类1,2,3级 一起查询
	findGoodsClassInfo(paramObj) {
		return post('/backend/goodsClass/find/findGoodsClassInfo', paramObj)
	},
	//添加商品分类
	addGoodsClass(paramObj) {
		return post('/backend/goodsClass/add/addGoodsClass', paramObj)
	},
	//编辑商品分类
	editGoodsClass(paramObj) {
		return post('/backend/goodsClass/edit/editGoodsClass', paramObj)
	},
	//查询店铺列表
	getStoreList(paramObj) {
		return post('/backend/store/find/findBywhere', paramObj)
	},
	//店铺审核
	editStoreInfoCheck(paramObj) {
		return post('/backend/store/edit/checkStore', paramObj)
	},

	//添加店铺信息-查询用户账号
	getStoreInfoUser(paramObj) {
		return post('/backend/user/seluser', paramObj)
	},
	//添加店铺
	addStore(paramObj) {
		return post('/backend/store/add/addStore', paramObj)
	},

	//根据id查询店铺信息
	getStoreId(paramObj) {
		return get('/backend/store/find/storeById/' + paramObj)
	},
	//根据id查询店铺信息
	editStoreById(paramObj) {
		return get('/backend/store/edit/blockUpOrStartUsing/' + paramObj)
	},
	//查询广告列表
	sysSliderList(paramObj) {
		return post('/api/advertising/findByWhere', paramObj)
	},
	//新增轮播
	addSysSliderInf(paramObj) {
		return post('/api/advertising/add/advInfo', paramObj)
	},
	//编辑轮播
	editSysSliderInfo(paramObj) {
		return post('/api/advertising/edit/advInfo', paramObj)
	},
	//删除轮播
	delSysSliderInfo(paramObj) {
		return get('/api/advertising/del/advInfo/' + paramObj)
	},
	//根据id查询轮播
	sysSliderInfo(paramObj) {
		return get('/api/advertising/find/findById/' + paramObj)
	},
	//轮播类型查询
	findSysSliderTypeList(paramObj) {
		return post('/api/sysSliderType/find/SysSliderTypeList', paramObj)
	},
	//订单查询
	storeOrderList(paramObj) {
		return post('/backend/storeOrder/find/StoreOrderList', paramObj)
	},
	//订单查询
	storeOrderListOffline(paramObj) {
		return post('/backend/ssStoreOrder/findOrderInfo', paramObj)
	},
	//根据订单ID查询详情
	findOrderInfo(paramObj) {
		return post('/backend/storeOrder/find/OrderInfo', paramObj)
	},
	orderAfterSale(paramObj){ //订单售后
		return post('/backend/goodsReturns/add', paramObj)
	},
	getOrderAfterSaleInfo(paramObj){ //查询订单售后记录列表
		return post('/backend/goodsReturns/list', paramObj)
	},
	sellAuditAfterSale(paramObj){ //商家审核售后申请
		return post('/backend/goodsReturns/agree', paramObj)
	},
	getOrderAfterSaleByID(paramObj){ //根据ID查询订单售后详情
		return get('/backend/goodsReturns/get/'+ paramObj)
	},
	uploadingExpressage(paramObj){ //买家上传退货信息
		return post('/backend/goodsReturns/send', paramObj)
	},
	orderAfterSaleByID(paramObj){ //根据ID查询订单售后处理记录
		return post('/backend/goodsReturnsRecord/list', paramObj)
	},
	adminAuditRefund(paramObj){ //平台审核是否退款
		return post('/backend/goodsReturns/confirm', paramObj)
	},
	sellAuditSignFor(paramObj){ //供应商是否确认收货
		return post('/backend/goodsReturns/receive', paramObj)
	},
	// 订单列表查询供应商和分销商下拉数据
	orderListGetInfo(paramObj) {
		return get('/backend/store/getList/'+ paramObj)
	},
	//查询发货的物流公司
	findAllOrderExpressList(paramObj) {
		return post('/api/sysExpress/find/express/list', paramObj)
	},
	//订单发货
	editStoreOrderStatus(paramObj) {
		return post('/backend/storeOrder/edit/StoreOrderStatus', paramObj)
	},
	// 订单补单
	OrdeRemplt(paramObj){
		return get('/backend/storeOrder/ReplacementOrder/'+paramObj)
	},
	//导出订单表格
	exportExcel(paramObj) {
		return toExcel('/backend/storeOrder/toExcel', paramObj)
	},
	//物流列表查询
	sysExpressList(paramObj) {
		return post('/api/sysExpress/find/SysExpressList', paramObj)
	},

	//添加物流公司
	addExpressList(paramObj) {
		return post('/api/sysExpress/add/SysExpressInfo', paramObj)
	},

	//根据id删除物流公司
	delSliderInfo(paramObj) {
		return get('/api/sysExpress/del/SysExpressInfo/?id=' + paramObj)
	},
	//根据id查询物流公司
	findSliderInfo(paramObj) {
		return get('/api/sysExpress/find/SysExpressInfo/?id=' + paramObj)
	},

	//编辑修改物流公司
	editExpressList(paramObj) {
		return post('/api/sysExpress/edit/SysExpressInfo', paramObj)
	},
	//区域代理列表查询
	userAreaList(paramObj) {
		return post('/backend/userArea/find/UserAreaList', paramObj)
	},
	//根据id代理详情修改
	findUserAreaInfo(paramObj) {
		return get('/backend/userArea/find/UserAreaInfo/?id=' + paramObj)
	},

	editUserAreaList(paramObj) {
		return post('/backend/userArea/edit/UserAreaInfo', paramObj)
	},
	//根据id改变代理状态
	delUserAreaInfo(paramObj) {
		return get('/backend/userArea/del/UserAreaInfo/?id=' + paramObj)
	},

	//查询资讯列表
	findNewsPostList(paramObj) {
		return post('/backend/newsPost/find/newsPostList', paramObj)
	},
	//添加资讯列表
	addNewsPost(paramObj) {
		return post('/backend/newsPost/add/newsPost', paramObj)
	},
	//根据id查询资讯信息
	getNewsPostById(paramObj) {
		return post('/backend/newsPost/find/newsPostInfo?id=' + paramObj)
	},
	//根据id查询资讯信息
	editNewsPost(paramObj) {
		return post('/backend/newsPost/edit/newsPost', paramObj)
	},

	//分币记录查询
	findFileCentsList(paramObj) {
		return post('/backend/fileCents/find/findFileCentsList', paramObj)
	},

	//算力记录列表
	findUserPowerList(paramObj) {
		return post('/backend/fileUserPowerList/find/findUserPowerList', paramObj)
	},

	//锁仓变动记录列表
	findFileLockedChangeRecordList(paramObj) {
		return post('/backend/fileLockedChangeRecord/find/findFileLockedChangeRecordList', paramObj)
	},
	//锁仓释放列表
	findFileLockedDetailList(paramObj) {
		return post('/backend/fileLockedDetail/find/findFileLockedDetailList', paramObj)
	},
	//省市区
	getArea(paramObj) {
		return post('/api/area/findArea/' + paramObj)
	},
	//查询省市区
	findUserArea(paramObj) {
		return get('/userArea/find/findUserArea', paramObj)
	},
	//添加省市区
	addUserArea(paramObj) {
		return post('/backend/userArea/add/UserAreaInfo', paramObj)
	},
	//修改省市区
	updateUserArea(paramObj) {
		return post('/userArea/update/updateUserArea', paramObj)
	},
	//帮助列表
	findArticles(paramObj) {
		return post('/backend/article/find/articles', paramObj)
	},
	//查询帮助列表
	findArticlesId(paramObj) {
		return get('/backend/article/find/article/' + paramObj)
	},
	//查询帮助类型
	findArticleTypes(paramObj) {
		return post('/backend/articleType/find/articleTypes', paramObj)
	},
	//查询帮助列表
	changeArticle(paramObj) {
		return post('/backend/article/change/article', paramObj)
	},
	//删除帮助
	delArticle(paramObj) {
		return get('/backend/article/del/article/' + paramObj)
	},
	//启用禁用
	upIsEnable(paramObj) {
		return post('/backend/article/IsEnable', paramObj)
	},
	//启用禁用
	upStatus(paramObj) {
		return post('/backend/articleType/IsStatus', paramObj)
	},
	//删除帮助类型
	delArticleType(paramObj) {
		return get('/backend/articleType/del/articleType/' + paramObj)
	},
	//新增帮助
	addArticle(paramObj) {
		return post('/backend/article/add/article', paramObj)
	},
	//新增帮助类型
	addArticleType(paramObj) {
		return post('/backend/articleType/add/articleType', paramObj)
	},
	//新增帮助类型
	findArticleTypeId(paramObj) {
		return get('/backend/articleType/find/articleType/' + paramObj)
	},
	//新增帮助类型
	changeArticleType(paramObj) {
		return post('/backend/articleType/change/articleType', paramObj)
	},
	//商家模糊查询
	findFlowRecord(paramObj) {
		return post('/backend/flowRecord/find/record', paramObj)
	},
	
	//导出会员资产列表
	memberExcel(paramObj) {
		return toExcel('/backend/property/toExcel', paramObj)
	},
	//导出会员列表
	memberListExcel(paramObj) {
		return toExcel('/backend/user/exportMemberList', paramObj)
	},
	//导出资产变动记录
	assetChangesExcel(paramObj) {
		return toExcel('/backend/tradingRecord/exportAssetChangeRecords', paramObj)
	},
	//导出提现列表
	withdrawalExcel(paramObj) {
		return toExcel('/backend/integralWithdrawal/exportWithdrawalList', paramObj)
	},
	//导出商品管理
	commodityExcel(paramObj) {
		return toExcel('/backend/storeGoods/productManagementExport', paramObj)
	},

	//看板数据
	homePageStatisticsQuery(paramObj) {
		return get('/backend/statistics/homePageStatisticsQuery', paramObj)
	},
	//商品选择供应商
	supplier(paramObj) {
		return post('/backend/supplier/find/suppinfo', paramObj)
	},
	//查询供应商
	suppinfoInfo(paramObj) {
		return post('/backend/supplier/find/suppinfoInfo', paramObj)
	},
	// 新增供应商
	Addsupp(paramObj) {
		return post('/backend/supplier/find/Addsupp', paramObj)
	},
	//修改供应商
	pusupp(paramObj) {
		return post('/backend/supplier/find/pusupp', paramObj)
	},
	//删除供应商
	deletesupp(paramObj) {
		return post('/backend/supplier/find/deletesupp', paramObj)
	},
	//查询酒柜订单
	jiuguiOrderZhuList(paramObj) {
		return post('/backend/jiuguiOrderZhu/find/jiuguiOrderZhuList', paramObj)
	},
	//酒柜订单商品详情
	jiuguiOrderCong(paramObj) {
		return post('/backend/jiuguiOrderCong/find/jiuguiOrderZhuList', paramObj)
	},
	//酒柜商品列表接口
	JiuGuiGoodssList(paramObj) {
		return post('/backend/jiuguiGoodss/find/JiuGuiGoodssList', paramObj)
	},
	//酒柜商品条件查询列表接口
	JiuGuiGoodssLists(paramObj) {
		return post('/backend/jiuguiGoodss/find/JiuGuiGoodssLists', paramObj)
	},
	//酒柜商品列表添加接口
	addJiuGuiGoodss(paramObj) {
		return post('/backend/jiuguiGoodss/add/addJiuGuiGoodss', paramObj)
	},
	//酒柜商品列表编辑接口
	editJiuGuiGoodss(paramObj) {
		return post('/backend/jiuguiGoodss/edit/editJiuGuiGoodss', paramObj)
	},
	//酒柜商品列表删除接口
	deleteJiuGuiGoodss(paramObj) {
		return get('/backend/jiuguiGoodss/delete/deleteJiuGuiGoodss/' + paramObj)
	},
	//酒柜商品列表查询供应商名称接口
	supplierNameList(paramObj) {
		return post('/backend/supplier/find/supplierNameList', paramObj)
	},
	//酒柜商品列表分成比例查询接口
	// goodssProportion(paramObj) {
	//  return post('/backend/jiuguiGoodss/find/goodssProportion',paramObj)
	// },
	//酒柜商品列表头部查询接口
	enableOrDisable(paramObj) {
		return get('/backend/jiuguiGoodss/edit/enableOrDisable/' + paramObj)
	},
	//酒柜商品列表根据ID查询详情接口
	queryOneDetails(paramObj) {
		return get('/backend/jiuguiGoodss/find/queryOneDetails/' + paramObj)
	},
	//全部酒柜列表接口
	findJiuGuiLists(paramObj) {
		return post('/backend/jiugui/findJiuGuiLists', paramObj)
	},
	//全部酒柜列表查询店铺接口
	storeNameList(paramObj) {
		return post('/backend/store/find/storeNameList', paramObj)
	},
	//全部酒柜列表酒柜的状态接口
	onOrOffTheShelf(paramObj) {
		return get('/backend/jiugui/edit/onOrOffTheShelf/' + paramObj)
	},
	//全部酒柜列表头部查询接口
	JiuGuiLists(paramObj) {
		return post('/backend/jiugui/find/JiuGuiLists', paramObj)
	},
	//全部酒柜列表新增酒柜接口
	addJiuGui(paramObj) {
		return post('/backend/jiugui/add/addJiuGui', paramObj)
	},
	//添加单位
	addPmsunit(paramObj){
		return post('/backend/pmsunit/add/addPmsunit',paramObj)
	},
	//编辑单位
	editPmsUnit(paramObj){
		return post('/backend/pmsunit/edit/editPmsUnit',paramObj)
	},
	findPmsUnit(paramObj){
		return post('/backend/pmsunit/find/findPmsUnit',paramObj)
	},
	deletePmsUnit(paramObj){
		return get('/backend/pmsunit/delete/deletePmsUnit/'+paramObj)
	},
	//分销商
	findIndentity(paramObj){
		return post('/backend/storeIdentity/find/findIndentity',paramObj)
	},
	addIndentity(paramObj){
		return post('/backend/storeIdentity/add/addIndentity',paramObj)
	},
	editIndentity(paramObj){
		return post('/backend/storeIdentity/edit/editIndentity',paramObj)
	},
	deleteIndentity(paramObj){
		return get('/backend/storeIdentity/delete/deleteIndentity/'+paramObj)
	},
	//分销商选品
	findFxGoods(paramObj){
		return post('/backend/storeGoods/find/findGoods',paramObj)
	},
	//商品选品列表
	addGood(paramObj){
		return post('/backend/PmsGoodsB/add/addGood',paramObj)
	},
	//选品列表
	findGoods(paramObj){
		return post('/backend/PmsGoodsB/find/findGoods',paramObj)
	},
	updGood(paramObj){
		return post('/backend/PmsGoodsB/upd/updGood',paramObj)
	},
	delGood(paramObj){
		return get('/backend/PmsGoodsB/del/delGood/'+paramObj)
	},
	delcGood(paramObj){
		return get('/backend/PmsGoodsB/upd/updGoodStatus/'+paramObj)
	},
	
	//品牌
	pmsbrdselect(paramObj){
		return post('/backend/pmsbrand/pmsbrdselectall',paramObj)
	},
	pmsbrdadd(paramObj){
		return post('/backend/pmsbrand/pmsbrdadd',paramObj)
	},
	pmsbrdupdate(paramObj){
		return post('/backend/pmsbrand/pmsbrdupdate',paramObj)
	},
	pmsbrdupdeletef(paramObj){
		return get('/backend/pmsbrand/pmsbrdupdeletef/'+paramObj)
	},
	
	findAreas(paramObj){
		return post('/api/area/findArea/'+paramObj)
	},
	addRecharge(paramObj){
		return post('/backend/rechargeRecord/add/addRecharge',paramObj)
	},
	findListById(paramObj){
		return get('/backend/storeCard/find/findListById/'+paramObj)
	},	
	//公共参数接口
	findSettingValueByKey(paramObj){
		return get('/api/sysSetting/v1/get/byKey?key='+paramObj)
	},	
	//修改商品禁售状态
	forbidSale(paramObj){
		return get('/backend/storeGoods/edit/forbidSale/'+paramObj)
	},	
	findByRechargeRecord(paramObj){
		return post('/backend/rechargeRecord/find/findByRechargeRecordList',paramObj)
	},
	//审核
	rechargeRejected(paramObj){
		return post('/backend/rechargeRecord/edit/rechargeRejected',paramObj)
	},
	rechargeBalance(paramObj){
		return post('/backend/rechargeRecord/edit/rechargeBalance',paramObj)
	},
	//添加收款方
	addcard(paramObj){
		return post('/backend/storeCard/add',paramObj)
	},
	//
	AmountSum(paramObj){
		return post('/backend/rechargeRecord/find/AmountSum',paramObj)
	},
	
	editcard(paramObj){
		return post('/backend/storeCard/edit',paramObj)
	},
	deletecard(paramObj){
		return del('/backend/storeCard/'+paramObj)
	},
	addNotifyUserRead(paramObj){
		return post('/backend/notifyUserRead/add/addNotifyUserRead',paramObj)
	},
	delivery(paramObj){
		return post('/backend/storeOrder/delivery',paramObj)
	},
	updateReceive(paramObj){
		return post('/backend/storeOrder/updateReceiveInformation',paramObj)
	},
	//审核S /B 端
	checkStore(paramObj){
		return post('/backend/store/edit/checkStore',paramObj)
	},
	//审核记录
	checkStore1(paramObj){
		return post('/api/StoreVertifyRecord/list',paramObj)
	},
	depositlist(paramObj){
		return post('/api/StoreDepositRecord/list',paramObj)
	},
	findshById(paramObj){
		return get('/api/StoreVertifyRecord/findById/'+paramObj)
	},
	//结算单列表
	setmentList(paramObj){
		return post('/backend/omsWithdrawal/list',paramObj)
	},
	//结算单列表 PC
	setmentListpc(paramObj){
		return post('/backend/omsWithdrawal/list/pc',paramObj)
	},
	// 结算单查看流程
	lookFlowList(paramObj){
		return get('/backend/OmsWithdrawalOperlist/list/'+paramObj)
	},
	// 结算单中的订单列表
	setOrderlist(paramObj){
		return get('/backend/storeOrder/chooseTheOrder/'+paramObj)
	},
	//结算单中选中订单
	setAddList(paramObj){
		return post('/backend/omsWithdrawalOrderList/addList',paramObj)
	},
	// 删除结算单中的订单
	setDeleat(paramObj){
		return del('/backend/omsWithdrawalOrderList/delete/'+paramObj)
	},
	//结算单中的上传图片
	uploadImg(paramObj){
		return post('/backend/omsWithdrawal/status3To4/',paramObj)
	},
	setRecords(paramObj){
		return get('/backend/omsWithdrawal/list/'+paramObj)
	},
	// 结算单平台状态通用接口
	setExmaine(paramObj){
		return post('/backend/omsWithdrawal/updateStatusAndRecord',paramObj)
	},
	// 结算单查看凭证
	setCrendatail(paramObj){
		return get('/backend/OmsWithdrawalOperlist/find/'+paramObj)
	},
	//结算单查看发票详情
	setDatail(paramObj){
		return get('/backend/OmsWithdrawalOperlist/findInvoice/'+paramObj)
	},
	// 结算单详情
	setOrderdetauil(paramObj){
		return post('/backend/omsWithdrawal/findOneBySwId/',paramObj)
	},
	//银行卡
	crandBank(paramObj){
		return get('/backend/storeCard/find/findListById/'+paramObj)
	},
	// 添加银行卡
	addCard(paramObj){
		return get('/backend/omsWithdrawal/addCardBank/'+paramObj)
	},
	//创建结算单
	creatSet(paramObj){
		return post('/backend/omsWithdrawal/findOne',paramObj)
	},
	listSum(paramObj){
		return post('/api/StoreDepositRecord/listSum',paramObj)
	},
	// 订单导出
	orderExcal(paramObj){
		return toExcel('/backend/storeOrder/export/Excel',paramObj)
	},
	// 批量发货模板
	mbExcal(paramObj){
		return toExcel('/backend/storeOrder/download/Excel',paramObj)
	},
	Jsdexport(paramObj){
		return toExcel('/backend/omsWithdrawal/export/'+paramObj)
	},
	
	//批量处理订单
	pldelivery(paramObj){
		return post('/backend/storeOrder/batch/delivery',paramObj)
	},
	//查看物流
	lookExpress(paramObj){
		return get('/backend/orderExpressDetail/findOrder/'+paramObj)
	},
	//驾驶人查询
	driverlist(paramObj){
		return post('/backend/driver/find/list',paramObj)
	},
	driverById(paramObj){
		return get('/backend/driver/findByID/'+paramObj)
	},
	adddriverlist(paramObj){
		return post('/backend/driver/add/driver',paramObj)
	},
	updriverlist(paramObj){
		return post('/backend/driver/update/driver',paramObj)
	},
	deleteByID(paramObj){
		return get('/backend/driver/deleteByID/'+paramObj)
	},
	//汽车管理
	carslist(paramObj){
		return post('/backend/cars/find/list',paramObj)
	},
	findcarsByID(paramObj){
		return get('/backend/cars/findByID/'+paramObj)
	},
	addcarslist(paramObj){
		return post('/backend/cars/add/cars',paramObj)
	},
	upcarslist(paramObj){
		return post('/backend/cars/update/cars',paramObj)
	},
	delcarsByID(paramObj){
		return get('/backend/cars/deleteByID/'+paramObj)
	},
	//商品管理
	carsgoodslist(paramObj){
		return post('/backend/storeGoods/find/list',paramObj)
	},
	
	findcarsgood(paramObj){
		return get('/backend/storeGoods/findByID/'+paramObj)
	},
	addcarsgoods(paramObj){
		return post('/backend/storeGoods/add/goods',paramObj)
	},
	upcarsgoods(paramObj){
		return post('/backend/storeGoods/update/goods',paramObj)
	},
	
	delcarsgood(paramObj){
		return get('/backend/storeGoods/deleteByID/'+paramObj)
	},
	//订单类别
	ordertypelist(paramObj){
		return post('/backend/orderType/find/list',paramObj)
	},
	
	factory(paramObj){ //客户管理
		return post('/backend/customer/list',paramObj)
	},
	addFactory(paramObj){ //客户管理-添加
		return post('/backend/customer/add',paramObj)
	},
	getFactoryByID(paramObj){ //客户管理-编辑查询
		return get('/backend/customer/get/'+paramObj)
	},
	updateFactory(paramObj){ //客户管理-编辑
		return post('/backend/customer/edit',paramObj)
	},
	delFactoryByID(paramObj){ //客户管理-删除
		return get('/backend/customer/delete/'+paramObj)
	},
	exportExcelFactory(paramObj) { //客户管理-导出
		return toExcel('/backend/customer/export/Excel', paramObj)
	},


	factoryNoPage(paramObj){ //客户管理查询-不分页
		return post('/backend/customer/find/list',paramObj)
	},
	clientLinkman(paramObj){ //客户联系人管理
		return post('/backend/customerLinks/list',paramObj)
	},
	addClientLinkman(paramObj){ //客户联系人管理-添加
		return post('/backend/customerLinks/add',paramObj)
	},
	getClientLinkmanByID(paramObj){ //客户联系人管理-编辑查询
		return get('/backend/customerLinks/get/'+paramObj)
	},
	updateClientLinkman(paramObj){ //客户联系人管理-编辑
		return post('/backend/customerLinks/edit',paramObj)
	},
	delClientLinkmanByID(paramObj){ //客户联系人管理-删除
		return get('/backend/customerLinks/delete/'+paramObj)
	},

	getProductList(paramObj){ //主营产品查询
		return post('/backend/customerClass/list',paramObj)
	},
	getProductClassByID(paramObj){ //主营产品-编辑查询
		return get('/backend/customerClass/get/'+paramObj)
	},
	addProductClass(paramObj){ //主营产品-添加
		return post('/backend/customerClass/add',paramObj)
	},
	updateProductClass(paramObj){ //主营产品-编辑
		return post('/backend/customerClass/edit',paramObj)
	},
	delProductClassByID(paramObj){ //主营产品-删除
		return get('/backend/customerClass/delete/'+paramObj)
	},


	getRoutetList(paramObj){ //运输线路查询
		return post('/backend/route/list',paramObj)
	},
	routetAddress(paramObj){ //运输线路出发地和到达地，地址查询
		return get('/backend/address/list',paramObj)
	},
	addRoutet(paramObj){ //运输线路-新增
		return post('/backend/route/add',paramObj)
	},
	getRoutetByID(paramObj){ //运输线路-编辑查询
		return get('/backend/route/get/'+paramObj)
	},
	updateRoutet(paramObj){ //运输线路-编辑
		return post('/backend/route/edit',paramObj)
	},
	delRoutet(paramObj){ //运输线路-删除
		return get('/backend/route/delete/'+ paramObj)
	},

	getWarehouseList(paramObj){ //仓库列表查询
		return post('/backend/wmsWarehouse/list',paramObj)
	},
	addWarehouseInfo(paramObj){ //新增仓库信息
		return post('/backend/wmsWarehouse/add',paramObj)
	},
	getWarehouseInfoByID(paramObj){ //仓库信息-编辑查询
		return get('/backend/wmsWarehouse/get/'+paramObj)
	},
	updateWarehouseInfo(paramObj){ //编辑仓库信息
		return post('/backend/wmsWarehouse/edit',paramObj)
	},
	warehouseDisableAndEnable(paramObj){ //仓库信息-禁用和启用
		return get('/backend/wmsWarehouse/status/'+paramObj)
	},


	getWarehouseListNoParameter(paramObj){ //仓库列表查询-无参数
		return post('/backend/wmsWarehouse/optionalList', paramObj)
	},
	getWarehouseDistrictList(paramObj){ //仓库库区列表查询
		return post('/backend/wmsWarehouseArea/list',paramObj)
	},
	addWarehouseDistrictInfo(paramObj){ //新增仓库库区信息
		return post('/backend/wmsWarehouseArea/add',paramObj)
	},
	getWarehouseDistrictInfoByID(paramObj){ //仓库库区信息-编辑查询
		return get('/backend/wmsWarehouseArea/get/'+paramObj)
	},
	updateWarehouseDistrictInfo(paramObj){ //编辑仓库库区信息
		return post('/backend/wmsWarehouseArea/edit',paramObj)
	},
	districtDisableAndEnable(paramObj){ //仓库库区-禁用和启用
		return get('/backend/wmsWarehouseArea/status/'+paramObj)
	},


	getDistrictListNoParameter(paramObj){ //仓库列表查询-传仓库id
		return post('/backend/wmsWarehouseArea/optionalList', paramObj)
	},
	getWarehouseLocationList(paramObj){ //仓库库位列表查询
		return post('/backend/wmsWarehouseLocation/list',paramObj)
	},
	addWarehouseLocationInfo(paramObj){ //新增仓库库位信息
		return post('/backend/wmsWarehouseLocation/add',paramObj)
	},
	getWarehouseLocationInfoByID(paramObj){ //仓库库位信息-编辑查询
		return get('/backend/wmsWarehouseLocation/get/'+paramObj)
	},
	updateWarehouseLocationInfo(paramObj){ //编辑仓库库位信息
		return post('/backend/wmsWarehouseLocation/edit',paramObj)
	},
	locationDisableAndEnable(paramObj){ //仓库库位-禁用和启用
		return get('/backend/wmsWarehouseLocation/status/'+paramObj)
	},

	getLocationListNoParameter(paramObj){ //库位列表查询-传库区id
		return post('/backend/wmsWarehouseLocation/optionalList', paramObj)
	},
	getLocationGoodsList(paramObj){ //库位商品信息查询
		return post('/backend/wmsGoodsLocation/list', paramObj)
	},
	getStateOfGoodsList(paramObj){ //货物状态查询
		return post('/backend/goodsStatus/optionalList', paramObj)
	},
	locationGoodsExcel(paramObj){ //导出
		return toExcel('/backend/wmsGoodsLocation/export/Excel',paramObj)
	},


	getLocationGoodsBatchList(paramObj){ //库位商品入库批次查询
		return post('/backend/wmsGoodsLocationBatch/list', paramObj)
	},
	locationGoodsBatchExcel(paramObj){ //导出
		return toExcel('/backend/wmsGoodsLocationBatch/export/Excel',paramObj)
	},
	locationGoodsBatchOperation(paramObj){ //库位商品入库批次查询 - 库存冻结或解冻
		return post('/backend/wmsGoodsLockRecord/add', paramObj)
	},


	getWarehouseCustomerList(paramObj){ //仓库客户信息查询
		return post('/backend/wmsWarehouseCustomer/list', paramObj)
	},
	getWarehouseListByNowUser(paramObj){ //仓库列表查询-当前登录用户
		return post('/backend/wmsWarehouse/list/optional', paramObj)
	},
	getWarehouseCustomerInfoByID(paramObj){ //根据客户ID查询仓库客户信息
		return get('/backend/wmsWarehouseCustomer/get/'+ paramObj)
	},
	addWarehouseCustomerInfo(paramObj){ //仓库客户信息 - 新增
		return post('/backend/wmsWarehouseCustomer/add', paramObj)
	},
	updateWarehouseCustomerInfo(paramObj){ //仓库客户信息 - 编辑
		return post('/backend/wmsWarehouseCustomer/edit', paramObj)
	},
	delWarehouseCustomerInfoByID(paramObj){ //根据ID仓库客户信息 - 删除
		return get('/backend/wmsWarehouseCustomer/delete/'+ paramObj)
	},
	WarehouseCustomerDisableAndEnable(paramObj){ //仓库客户根据ID - 停用或启用
		return get('/backend/wmsWarehouseCustomer/status/'+ paramObj)
	},

	getTransLogList(paramObj){ //动碰盘点信息查询
		return post('/backend/wmsTransLog/list', paramObj)
	},

	storageAgeQueryList(paramObj){ //库龄查询
		return post('/backend/wmsGoodsLocationBatch/dong/list', paramObj)
	},
	storageAgeExcel(paramObj){ //库龄查询 - 导出
		return toExcel('/backend/wmsGoodsLocationBatch/dong/Excel', paramObj)
	},


	getStateOFGoodsList(paramObj){ //货物状态定义表格查询
		return post('/backend/goodsStatus/list', paramObj)
	}, 
	addStateOFGoodsInfo(paramObj){ //货物状态定义 - 新增
		return post('/backend/goodsStatus/add', paramObj)
	}, 
	getStateOFGoodsInfoByID(paramObj){ //货物状态定义根据ID查询
		return get('/backend/goodsStatus/get/'+ paramObj)
	},
	updateStateOFGoodsInfo(paramObj){ //货物状态定义 - 编辑
		return post('/backend/goodsStatus/edit', paramObj)
	}, 
	delStateOFGoodsInfoByID(paramObj){ //货物状态定义根据ID删除
		return get('/backend/goodsStatus/delete/'+ paramObj)
	},

	getSerialNumber(){ //请求入库订单号
		return get('/backend/wmsInOrder/random')
	},
	getWarehouseWarrantList(paramObj){ //入库单表格查询
		return post('/backend/wmsInOrder/list', paramObj)
	}, 
	delWarehouseWarrantInfoByID(paramObj){ //入库单删除
		return get('/backend/wmsInOrder/delete/'+ paramObj)
	},
	addWarehouseWarranOrder(paramObj){ //入库单新增-基本信息
		return post('/backend/wmsInOrder/add', paramObj)
	}, 
	addWarehouseWarranOrderList(paramObj){ //入库单新增-商品信息
		return post('/backend/wmsInOrderDetail/add', paramObj)
	},
	getRightGoodsList(paramObj){ //入库单-新增商品库位时查询已新增的商品信息
		return post('/backend/wmsInOrderDetail/optionalList', paramObj)
	},
	addWarehouseWarranOrderListRight(paramObj){ //入库单新增-商品库位信息(右边)
		return post(
			// '/backend/wmsInOrderDetail/add'
			'/backend/wmsInOrderList/add', paramObj)
	}, 
	updateWarehouseWarranOrderListRight(paramObj){ //入库单编辑-商品库位信息(右边)
		return post(
			// '/backend/wmsInOrderDetail/edit'
			'/backend/wmsInOrderList/edit'
			, paramObj)
	}, 
	getWarehouseWarrantInfoByID(paramObj){ //入库单查询 - 根据ID查询
		return get('/backend/wmsInOrder/get/'+ paramObj)
	},
	getWarehouseWarrantInfoByIDList(paramObj){ //入库单查询 - 根据ID批量查询
		return post('/backend/wmsInOrder/arrList', paramObj)
	},
	updateWarehouseWarranOrder(paramObj){ //入库单编辑-基本信息
		return post('/backend/wmsInOrder/edit', paramObj)
	}, 
	deldWarehouseWarranOrder(paramObj){ //入库单-商品信息-删除(左边)
		return get('/backend/wmsInOrderDetail/delete/'+paramObj)
	},
	deldWarehouseWarranOrderRight(paramObj){ //入库单-商品信息-删除(右边)
		return get('/backend/wmsInOrderList/delete/'+paramObj)
	},
	updateWarehouseWarranOrderList(paramObj){ //入库单编辑-商品信息
		return post('/backend/wmsInOrderDetail/edit', paramObj)
	}, 
	warehouseWarrantPrint(paramObj){ //入库单打印
		return post('/backend/wmsOrderPrint/add', paramObj)
	},
	warehouseWarrantPrintList(paramObj){ //入库单打印-批量
		return post('/backend/wmsOrderPrint/batchAdd', paramObj)
	},
	warehouseWarrantUpdateStatus(paramObj){ //入库单 - 入库中、关单
		return get('/backend/wmsInOrder/updateStatus/'+ paramObj)
	},
	oneClickInTheLibrary(paramObj){ //一键入库中
		return post('/backend/wmsInOrder/arrList1', paramObj)
	},
	oneClickOrder(paramObj){ //一键关单
		return post('/backend/wmsInOrder/arrList2', paramObj)
	},


	outboundDeliveryOrderList(paramObj){ //出库单表格查询
		return post('/backend/wmsOutOrder/list', paramObj)
	}, 
	delOutboundDeliveryByID(paramObj){ //入库单删除
		return get('/backend/wmsOutOrder/delete/'+ paramObj)
	},
	outboundDeliveryUpdateStatus(paramObj){ //出库单 - 入库中、关单
		return get('/backend/wmsOutOrder/updateStatus/'+ paramObj)
	},
	oneClickInTheLibraryOutbound(paramObj){ //一键出库中
		return post('/backend/wmsOutOrder/arrList1', paramObj)
	},
	oneClickOrderOutbound(paramObj){ //一键关单
		return post('/backend/wmsOutOrder/arrList2', paramObj)
	},
	getSerialNumberOut(){ //请求出库单号
		return get('/backend/wmsOutOrder/random')
	},
	addOutboundDeliveryOrderInfo(paramObj){ //出库单新增-基本信息
		return post('/backend/wmsOutOrder/add', paramObj)
	}, 
	getOutboundDeliveryOrderInfoByID(paramObj){ //出库单查询 - 根据ID查询
		return get('/backend/wmsOutOrder/get/'+ paramObj)
	},
	getOutboundDeliveryOrderInfoByIDList(paramObj){ //出库单查询 - 根据ID批量查询
		return post('/backend/wmsOutOrder/arrList', paramObj)
	},
	updateOutboundDeliveryOrderInfo(paramObj){ //出库单编辑-基本信息
		return post('/backend/wmsOutOrder/edit', paramObj)
	}, 
	addOutboundDeliveryOrderInfoLeft(paramObj){ //出库单-新增商品信息
		return post('/backend/wmsOutOrderDetail/add', paramObj)
	}, 
	updateOutboundDeliveryOrderInfoLeft(paramObj){ //出库单-编辑商品信息
		return post('/backend/wmsOutOrderDetail/edit', paramObj)
	}, 
	delOutboundDeliveryOrderInfoLeft(paramObj){ //出库单-删除商品信息
		return get('/backend/wmsOutOrderDetail/delete/'+ paramObj)
	}, 
	updateOutboundDeliveryOrderInfoRight(paramObj){ //出库单-编辑商品库存库位信息
		return post('/backend/wmsOutOrderList/edit', paramObj)
	}, 
	addOutboundDeliveryOrderInfoRight(paramObj){ //出库单-新增商品库存库位信息
		return post('/backend/wmsOutOrderList/add', paramObj)
	}, 
	delOutboundDeliveryOrderInfoRight(paramObj){ //出库单-删除商品库存库位信息
		return get('/backend/wmsOutOrderList/delete/'+ paramObj)
	},
	getLocationListRight(paramObj){ //出库单-右边库位查询
		return post('/backend/wmsGoodsLocationBatch/option/list', paramObj)
	}, 
	outboundDeliveryPrint(paramObj){ //出库单打印
		return post('/backend/wmsOrderPrint/add1', paramObj)
	},
	outboundDeliveryPrintList(paramObj){ //入库单打印-批量
		return post('/backend/wmsOrderPrint/batchAdd1', paramObj)
	},

	wmsTransOrdertList(paramObj){ //移库单列表查询
		return post('/backend/wmsTransOrder/list', paramObj)
	},
	delWmsTransOrdertInfoByID(paramObj){ //移库单删除
		return get('/backend/wmsTransOrder/delete/'+ paramObj)
	},
	wmsTransOrdertUpdateStatus(paramObj){ //移库单 - 移库库中、关单
		return get('/backend/wmsTransOrder/updateStatus/'+ paramObj)
	},
	getClientListByWarehouse(paramObj){ //根据仓库查询客户
		return post('/backend/wmsGoodsLocationBatch/optional/customerList', paramObj)
	},
	getGoodsListByWarehouseAndClient(paramObj){ //根据仓库和客户查询商品
		return post('/backend/wmsGoodsLocationBatch/trans/list', paramObj)
	},
	getSerialNumberWmsTransOrder(){ //请求移库订单号
		return get('/backend/wmsTransOrder/random')
	},
	addWmsTransOrderInfo(paramObj){ //移库单新增-基本信息
		return post('/backend/wmsTransOrder/add', paramObj)
	}, 
	getWmsTransOrderInfoByID(paramObj){ //移库单根据ID查询信息
		return get('/backend/wmsTransOrder/get/'+ paramObj)
	}, 
	updateWmsTransOrderInfo(paramObj){ //移库单修改-基本信息
		return post('/backend/wmsTransOrder/edit', paramObj)
	},
	addWmsTransOrderGoodsList(paramObj){ //移库单商品信息-新增
		return post('/backend/wmsTransOrderList/add', paramObj)
	},
	updateWmsTransOrderGoodsList(paramObj){ //移库单商品信息-修改
		return post('/backend/wmsTransOrderList/edit', paramObj)
	},
	delWmsTransOrderGoodsListByID(paramObj){ //移库单商品信息-删除
		return get('/backend/wmsTransOrderList/delete/'+ paramObj)
	},



	queryByCustomerList(paramObj){ //按客户查询
		return post('/backend/wmsGoodsLocationBatch/customerList', paramObj)
	}, 


	findordertype(paramObj){
		return get('/backend/orderType/findByID/'+paramObj)
	},
	addordertype(paramObj){
		return post('/backend/orderType/add/orderType',paramObj)
	},
	upordertype(paramObj){
		return post('/backend/orderType/update/orderType',paramObj)
	},
	
	delordertype(paramObj){
		return get('/backend/orderType/deleteByID/'+paramObj)
	},
	//查询客户
	findcusomer(paramObj){
		return post('/backend/customer/find/list',paramObj)
	},
	addresslist(paramObj){
		return post('/backend/address/find/list',paramObj)
	},
	findaddress(paramObj){
		return get('/backend/address/findByID/'+paramObj)
	},
	addaddress(paramObj){
		return post('/backend/address/add/address',paramObj)
	},
	upaddress(paramObj){
		return post('/backend/address/update/address',paramObj)
	},
	
	deladdress(paramObj){
		return get('/backend/address/deleteByID/'+paramObj)
	},
	findorder(paramObj){
			return post('/backend/order/find/list',paramObj)
		},
	delorder(paramObj){
		return get('/backend/order/deleteByID/'+paramObj)
	},
	addneworder(){
		return get('/backend/order/add/order')
	},
	orderlist(paramObj){
			return post('/backend/orderType/find/DropdownList',paramObj)
		},
	findgs(paramObj){
		return post('/backend/storeGoods/find/DropdownList',paramObj)
	},
	findrouteList(paramObj){
		return post('/backend/route/find/list',paramObj)
	},
	addorderL(paramObj){  
		return post('/backend/orderList/add/orderList',paramObj)
	},
	fcarsList(paramObj){
		return post('/backend/cars/find/DropdownList',paramObj)
	},
	fdriverList(paramObj){
		return post('/backend/driver/find/DropdownList',paramObj)
	},
	fupdateorder(paramObj){
		return post('/backend/order/update/order',paramObj)
	},
	fidupdateorder(paramObj){
		return get('/backend/order/findByID/'+paramObj)
	},
	deldateorder(paramObj){
		return get('/backend/orderList/deleteByID/'+paramObj)
	},
	uporderList(paramObj){
		return post('/backend/orderList/update/orderList',paramObj)
	},
	 completeByID(paramObj){
	 	return get('/backend/order/completeByID/'+paramObj)
	 },
	 dcorder(paramObj){
	 	return toExcel('/backend/order/export/Excel',paramObj)
	 },
	wcorder(paramObj){
		return post('/backend/order/batchArrival',paramObj)
	},
	

	//商品管理导出表格
	goodsListExportExcel(paramObj) {
		return toExcel('/backend/storeGoods/export/Excel', paramObj)
	},

	//运输路线导出表格
	routeListExportExcel(paramObj) {
		return toExcel('/backend/route/export/Excel', paramObj)
	},

	//司机列表导出表格
	driverListExportExcel(paramObj) {
		return toExcel('/backend/driver/export/Excel', paramObj)
	},

	//车辆管理导出表格
	cartListExportExcel(paramObj) {
		return toExcel('/backend/cars/export/Excel', paramObj)
	},

	//库位管理导出表格
	wmsWarehouseLocationListExportExcel(paramObj) {
		return toExcel('/backend/wmsWarehouseLocation/export/Excel', paramObj)
	},
	
	//入库单列表导出表格
	wmsInOrderListExportExcel(paramObj) {
		return toExcel('/backend/wmsInOrder/export/Excel', paramObj)
	},

	//出库单列表导出表格
	wmsOutOrderListExportExcel(paramObj) {
		return toExcel('/backend/wmsOutOrder/export/Excel', paramObj)
	},

	getGoodsTransStatusList(paramObj){ //货物状态转换
		return post('/backend/wmsGoodsTransStatus/list',paramObj)
	},
	addGoodsTransStatusInfo(paramObj){ //货物状态转换 - 新增
		return post('/backend/wmsGoodsTransStatus/add',paramObj)
	},
}
